import classNames from 'classnames';
import T from '../../../../../../common/components/T';
import { Portal, svgSprite } from '../../../../../../hybrid/wrappers';
import css from './CurrencyItem.module.scss';
import React, { useMemo, useState, useCallback, useContext, useEffect } from 'react';
import { navigateV2, dataSender } from '../../../../../../common/utils/router';
import { API_SERVER_URL } from '../../../../../../common/utils/utils';
import UserContext from '../../../../../../common/utils/getContext';
import SingleButton from '../../../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';

const CurrencyItem = (props) => {
    const { account, outMoneyHandler, wallet, radioSwitcher } = props;
    const { userToken, setAlertData, lang } = useContext(UserContext);
    const [allowSend, setAllowSend] = useState(true);
    const number_of_buttons = useMemo(() => {
        let num = 0;
        if (account.replenishment) num += 1;
        if (account.withdrawal) num += 1;
        if (account.internal_transfer) num += 1;
        if (account.transfer_to_user || account.own_transfer) num += 1;
        return num;
    }, [account]);
    const [transferModal, setTransferModal] = useState(false);

    useEffect(() => {
        if (!transferModal) {
            setAllowSend(true);
        }
    }, [transferModal]);
    const sendTransfer = useCallback(
        (credit, debit, amount) => {
            if (allowSend) {
                dataSender(
                    `${API_SERVER_URL}/api/v1/user/finance/currency-transactions/transfer`,
                    'POST',
                    {
                        credit_currency_account_id: credit,
                        debit_currency_account_id: debit,
                        amount: amount
                    },
                    () => {
                        setAlertData({
                            type: 'success',
                            cont: <T textName='confirmModal-sender-success' defaultStr='Средства преведены' />
                        });
                        setTransferModal(false);
                    },
                    () => {
                        setAlertData({
                            type: 'error',
                            cont: <T textName='confirmModal-sender-error' defaultStr='Произошла ошибка' />
                        });
                        setTransferModal(false);
                    },
                    userToken,
                    lang,
                    false,
                    'form-data'
                );
            }
        },
        [userToken, lang, allowSend, setAlertData]
    );

    return (
        <div className={css.wrapper}>
            <div className={css.currencyHead}>
                <div className={css.currencyHeadIcon}>{svgSprite('bonus-account-icon')}</div>
                <p className={css.currencyHeadName}>{account?.accountCurrency?.code}</p>
            </div>
            <div className={css.balance}>
                <p className={css.balanceLabel}>
                    <T textName='balance' defaultStr='Баланс' />:
                </p>
                <p className={css.balanceValue}>
                    <span>
                        {+radioSwitcher === 1
                            ? Number(account?.balance)?.toLocaleString().replace(',', '.')
                            : Number(account?.formatted_currency_balance?.replace(/[^\d.]/g, ''))
                                  .toLocaleString()
                                  ?.replace(',', '.')}{' '}
                    </span>
                    <span>{+radioSwitcher === 1 ? account?.main_currency?.code : account?.accountCurrency?.code}</span>
                </p>
            </div>
            <div
                style={{ gridTemplateColumns: `repeat(${number_of_buttons}, 1fr)` }}
                className={classNames(css.buttons, number_of_buttons === 0 && css.dn)}
            >
                {account.replenishment && (
                    <div
                        className={classNames(css.walletButton)}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigateV2(`/wallets/inmoney/${wallet.id}?ca=${account.id}`);
                        }}
                    >
                        <span className={css.walletButtonText}>
                            <T textName='replenish' defaultStr='Пополнить' />
                        </span>
                    </div>
                )}
                {account.withdrawal ? (
                    <div className={classNames(css.walletButton)} onClick={(e) => outMoneyHandler(e, account)}>
                        <span className={css.walletButtonText}>
                            <T textName='withdraw' defaultStr='Вывести' />
                        </span>
                    </div>
                ) : null}
                {account.transfer_to_user || account?.own_transfer ? (
                    <div
                        className={classNames(css.walletButton)}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigateV2(`/wallets/transfermoney/${wallet?.id}?ca=${account.id}`);
                        }}
                    >
                        <span className={css.walletButtonText}>
                            <T textName='transfer' defaultStr='Перевод' />
                        </span>
                    </div>
                ) : null}
                {account.internal_transfer ? (
                    <div
                        className={classNames(css.walletButton)}
                        onClick={(e) => {
                            e.stopPropagation();
                            setTransferModal(true);
                        }}
                    >
                        <span className={css.walletButtonText}>
                            <T textName='confirm-modal-transfer-btn' defaultStr='Перевод между балансами' />
                        </span>
                    </div>
                ) : null}
            </div>

            {transferModal ? (
                <Portal closeHandler={() => setTransferModal(false)}>
                    <div className={css.modalWrapper}>
                        <div className={css.modalClose} onClick={() => setTransferModal(false)}>
                            {svgSprite('cross', { className: css.modalCloseIcon })}
                        </div>
                        <div className={css.modalTitleWrap}>
                            <p className={css.modalTitle}>
                                <T
                                    textName='confirm-modal-trasfer-to-main'
                                    defaultStr='Вы уверены что хотите перевести все средства с текущего баланса на основной баланс бонусного счета?'
                                />
                            </p>
                        </div>
                        <div className={css.modalFooterBtn}>
                            <SingleButton
                                customStyles={css}
                                type={'cancel'}
                                clickFunc={() => setTransferModal(false)}
                                buttonText={<T textName='confirm-modal-btn-cancel' defaultStr='Отмена' page='/store' />}
                            />
                            <SingleButton
                                customStyles={css}
                                type={'ok'}
                                clickFunc={() => {
                                    sendTransfer(
                                        account.id,
                                        wallet.currency_accounts.filter((i) => i.is_main)[0].id,
                                        account.balance
                                    );
                                    setAllowSend(false);
                                }}
                                buttonText={<T textName='confirm-modal-btn-success' defaultStr='Подтвердить' page='/store' />}
                            />
                        </div>
                    </div>
                </Portal>
            ) : null}
        </div>
    );
};

export default CurrencyItem;
